import { gql } from "@apollo/client";

const InsertQuery = gql`
mutation InserECUsers($object: ec_users_insert_input = {}) {
  insert_ec_users_one(object: $object) {
    id
  }
}
`

export const InsertECUsers = async (
    data,
    client,
) => {
    let resp;
    try {
        // const loginId = JSON.parse(localStorage.getItem('gogo_current_user')).id
        // const merchantId = JSON.parse(localStorage.getItem('gogo_current_user')).merchant_id

        resp = await client.mutate({
            mutation: InsertQuery,
            // refetchQueries: [getQuery],
            variables: {
                "object": {
                    "phone_number": data?.mobile,
                    "name": data?.name,
                    "email": data?.email||"",
                    "country_code":data?.country_code||"+91"
                }
            },
            context: {
                headers: {
                    "Content-Type": "application/json",
                    //   "x-hasura-admin-secret": "aseraadmin@1234",
                    'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
                },
            },
        });
        if (resp.errors) {
            return { success: false }
        }
        // window.location.reload();
    } catch (e) {
        console.log(JSON.stringify(e));
        // showFailureAlert('Something went wrong while updating your cart');
    }
    return { success: true, data: resp.data }
};